import { RemoveSessionToken } from "./store";
import { Router } from "../router";

declare global {
  interface Window {
    WevNative?: {
      onEvent: (event: string) => void;
    };
    webkit?: {
      messageHandlers: {
        onEvent: {
          postMessage: (event: { id: string; name: string }) => void;
        };
      };
    };
  }
}

const logout = () => {
  RemoveSessionToken();
  const userAgent = window.navigator.userAgent;
  if (userAgent.match(/(?=.*WeverseBackstage)/)) {
    const event = {
      id: crypto.randomUUID() || "unknown",
      name: "closeWebView",
    };

    if (userAgent.match(/(?=.*(?:iPhone|iPad|iPod))/)) {
      // iOS
      window.webkit?.messageHandlers.onEvent.postMessage(event);
    } else {
      // android
      window.WevNative?.onEvent(JSON.stringify(event));
    }
  } else {
    Router.navigate("/login").then();
  }
};

export { logout };
